/**
 * O que faz: Indicador de carregamento com as animações dotted orbs (thinking-orbs).
 * Onde usa: Telas de autenticação, gates de assinatura e outros loadings em tela cheia/inline.
 * Conexões: Pacote npm thinking-orbs (ThinkingOrb).
 * Tabelas: Nenhuma.
 * Data: 23/07/2026.
 */

import { ThinkingOrb, type OrbSize, type OrbState, type OrbTheme } from 'thinking-orbs';

interface ThinkingOrbLoaderProps {
  /** Estado da animação — no auth inicial usamos "solving" (faixas que se encaixam). */
  state?: OrbState;
  /** Preset do pacote: 64 (destaque) ou 20 (inline). */
  size?: OrbSize;
  /** Tema monochrome; auto segue dark/light do app. */
  theme?: OrbTheme;
  /** Texto abaixo da orb (ex.: "Verificando autenticação..."). */
  label?: string;
  /** Classes extras no container (espaçamento, alinhamento). */
  className?: string;
  /** Rótulo acessível; se omitido, usa o label ou um padrão em PT-BR. */
  'aria-label'?: string;
}

/**
 * Wrapper simples para reutilizar ThinkingOrb sem repetir imports e tamanhos.
 * Motivo: centralizar o padrão visual de loading e facilitar trocas futuras de state.
 */
export function ThinkingOrbLoader({
  state = 'solving',
  size = 64,
  theme = 'auto',
  label,
  className = '',
  'aria-label': ariaLabel,
}: ThinkingOrbLoaderProps) {
  const rotuloAcessivel = ariaLabel || label || 'Carregando';

  return (
    <div className={`flex flex-col items-center justify-center ${className}`.trim()}>
      <ThinkingOrb
        state={state}
        size={size}
        theme={theme}
        aria-label={rotuloAcessivel}
        className={label ? 'mb-4' : undefined}
      />
      {label ? (
        <p className="text-gray-600 text-center text-sm sm:text-base">{label}</p>
      ) : null}
    </div>
  );
}
